module.exports = __webpack_public_path__ + "static/media/R-Smart MotorS.94a263a0.jpg";